<template>
    <div>
        <div class="c-quantity-text-first-wrap">
            <span style="color: #0070ba; font-weight: bold">Esta opción de variedad tiene un pedido mínimo de semillas.</span><br>
            <span style="color: rgb(116 116 116);">Selecciona una de las cantidades establecidas de bandejas</span>
        </div>
        <div class="c-quantity-formats-box">
            <div class="c-quantity-text top">
                Nº de alvéolos por bandeja
                <img v-b-modal.modal-nalveolos src="/img/iconos/icon_info.svg" alt="icon_info.svg" class="icon_info">
                <modal-block v-cloak title="Nº de alvéolos por bandeja" :href="route('help.details','dimensiones-alveolos')" desing="ecologico" refer="nalveolos">
                    Cantidad de alvéolos por bandeja, el tamaño varía dependiendo del número alvéolos.
                </modal-block>
                <b-form-checkbox class="c-quentity-format-recommend" v-model="showRecommended">
                    El formato de bandeja que Babyplant me recomienda
                    <img v-b-modal.modal-formatorec src="/img/iconos/icon_info.svg" alt="icon_info.svg" class="icon_info">
                    <modal-block v-cloak title="No toda semilla germina" desing="ecologico" refer="formatorec">
                        Recuerda que no toda la semilla germina, te garantizamos como mínimo un 90% del número de plantas.
                    </modal-block>
                </b-form-checkbox>
            </div>
            <div class="c-inputs-box">
                <div class="c-num-plants-wrap">
                    <div class="c-num-plants">
                        Número de plantas
                        <img v-b-modal.modal-nplantas src="/img/iconos/icon_info_white.svg" alt="icon_info_white.svg" class="icon_info">
                        <modal-block v-cloak title="Número de plantas" desing="ecologico" refer="nplantas">
                            Número total de plantas que recibirás independientemente del formato de bandeja que escojas
                        </modal-block>
                    </div>
                    <div class="tray-format-border"></div>
                    <div v-for="multiple in multiples" class="c-num-alveoli"> {{ numPlantsByMultiple(multiple)}} </div>
                </div>
                <div v-for="(trayFormat, index) in trayFormats" :class="{'tray-format-column-first': index === 0}">
                    <div class="c-num-alveoli" :class="{'recommended': trayFormat.id === trayFormatRecommendedId && showRecommended}">
                        <div v-if="trayFormat.id === trayFormatRecommendedId && showRecommended" class="recommended-border"></div>
                        {{ trayFormat.unidades }}
                    </div>
                    <div class="tray-format-border"></div>
                    <div class="c-num-trays" v-for="multiple in multiples" @click="selectTrays(trayFormat, multiple)"
                         :class="{selected: isSelected(trayFormat, multiple)}">
                        {{ numTraysByTrayFormat(trayFormat, multiple) }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AlveolusQuantityMinOrder",
        props: {
            trayFormats: {
                type: Array,
                default: []
            },
            alveolusQuantity: {
                type: Number,
                default: 1
            },
            minOrderSeeds: {
                type: Number,
                required: true
            },
            seedLostPercent: {
                type: Number
            },
            multiples: {
                type: Number,
                default: 4
            },
            trayFormatRecommendedId: {
                type: Number|String
            },
            injerto: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                loadingTrayFormats: false,
                showRecommended: false
            }
        },
        computed: {
            numPlantsByPackage() {
                return Math.floor(this.minOrderSeeds / this.alveolusQuantity * (1 - this.seedLostPercent / 100));
            },
            trayFormatSelected() {
                let trayFormatsWithValues = this.trayFormats.filter(tf => tf.value > 0);
                if (trayFormatsWithValues.length > 1) {
                    throw "Solo puede haber una bandeja seleccionada";
                }
                return trayFormatsWithValues.find(tf => tf.value > 0);
            },
            maxPlantsBySelected() {
                let max = 0;
                if (this.trayFormatSelected) {
                    max = this.trayFormatSelected.unidades * this.trayFormatSelected.value;
                }
                return max;
            },
            multiplierSelected() {
                let multiplier = 0;
                if (this.maxPlantsBySelected) {
                    multiplier = Math.floor(this.maxPlantsBySelected / this.numPlantsByPackage);
                }
                return multiplier;
            },
            numPlants() {
                return this.multiplierSelected * this.numPlantsByPackage;
            }
        },
        watch: {
            numPlants() {
                this.$emit('num-plants-changed', this.numPlants);
            },
            alveolusQuantity() {
                this.trayFormats.forEach(tf => {
                    tf.value = 0;
                });
                this.$emit('num-plants-changed', 0);
            }
        },
        methods: {
            input(trayFormat, value) {
                let newValue = parseInt(value);
                if (isNaN(newValue)) {
                    newValue = trayFormat.value;
                }
                trayFormat.value = newValue;
                this.$forceUpdate();
            },
            numTraysByTrayFormat(trayFormat, multiple) {
                let numTrays = this.numPlantsByMultiple(multiple) / trayFormat.unidades;
                if (!this.injerto) {
                    numTrays = this.minOrderSeeds / this.alveolusQuantity / trayFormat.unidades * multiple;
                }
                return Math.ceil(numTrays);
            },
            numPlantsByMultiple(multiple) {
                return multiple * this.numPlantsByPackage;
            },
            multipleByNumPlants() {
                return this.numPlants / this.numPlantsByPackage;
            },
            selectTrays(trayFormat, multiple) {
                this.trayFormats.forEach(tf => {
                    tf.value = 0;
                });
                this.input(trayFormat, this.numTraysByTrayFormat(trayFormat, multiple));
            },
            isSelected(trayFormat, multiple) {
                return trayFormat.value > 0 && multiple === this.multipleByNumPlants();
            }
        },
        created() {
            this.$emit('num-plants-changed', this.numPlants);
        }
    }
</script>

<style scoped>

    .c-inputs-box {
        display: flex;
        margin: -0.5rem -0.2rem 0 0;
        overflow-x: auto;
        overflow-y: visible;
    }

    .c-inputs-box > * {
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
    }

    .c-inputs-box > * > * {
        flex: 0 0 4.5rem;
        margin: 0.5rem 0.2rem;
        height: 2.5rem;
        max-height: 2.5rem;
        max-width: 4.5rem;
        min-width: 4.5rem;
    }

    .c-num-alveoli {
        padding: 0.375rem 0.75rem;
        background-color: #fbc531;
        border-radius: 0.25rem;
        color: #0b72b8;
        font-size: 1em;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .c-num-alveoli.recommended {
        background-color: #048b84;
        color: #fff;
        position: relative;
    }

    .c-num-alveoli.recommended .recommended-border {
        width: calc(100% + 8px);
        height: calc(100% + 8px);
        position: absolute;
        left: -4px;
        top: -4px;
        border: solid 1px #048b84;
        border-radius: 0.25rem;
    }

    .tray-format-column-first {
        margin-left: 0.3rem;
    }

    .c-num-trays {
        padding: 0.375rem 0.75rem;
        border-radius: 0.25rem;
        font-size: 1em;
        border: solid 1px #cbc8c9;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }

    .c-num-trays:hover {
        border-color: rgb(0, 112, 186);
    }

    .c-num-trays.selected {
        color: #fff;
        background-color: #0e74b7;
        border-color: #3aa7dd;
    }

    .c-quantity-formats-box .c-quantity-text {
        text-align: left;
        font-weight: bold;
        line-height: 1;
    }

    .c-quentity-format-recommend {
        text-align: left;
        font-weight: bold;
        color: #048b84;
        margin-top: 0.5rem;
    }

    .c-quantity-formats-box .c-quantity-text.top {
        margin-bottom: 0.75rem;
        font-size: 0.9em;
        margin-left: 6.25rem;
    }

    .c-quantity-formats-box .c-quantity-text.bottom {
        margin-top: 0.75rem;
    }

    .c-num-plants-wrap {
        background: #038a84;
        padding-left: 0.4rem;
        padding-right: 0.4rem;
        padding-bottom: 0.2rem;
    }

    .c-num-plants {
        font-size: 0.9em;
        font-weight: bold;
        color: #ffffff;
    }

    .c-num-plants img.icon_info {
        width: 1em;
    }

    .c-quantity-text-first-wrap {
        padding-bottom: 0.5rem;
    }

    .tray-format-border {
        margin: 0;
        flex: 0;
        border: 1px solid rgba(0, 0, 0, 0.2);
        max-width: 100%;
    }

    .c-num-plants-wrap .tray-format-border {
        border-color: transparent;
    }

    .c-quantity-text.top img.icon_info {
        width: 20px;
    }

    @media (min-width: 992px) {
        .c-quantity-formats-box {
            padding: 0.75rem 0.8rem 0 0;
            border-bottom-left-radius: 0.25rem;
            border-bottom-right-radius: 0.25rem;
            border: 1px solid #cbc8c9;
            border-top: 0;
        }

        .c-quantity-formats-box .c-quantity-text.top {
            margin-bottom: 0.75rem;
            margin-left: 7.5rem;
        }

        .c-quantity-formats-box .c-quantity-text.bottom {
            margin-top: 1rem;
        }

        .c-quantity-text-first-wrap {
            border: solid 1px #0070ba;
            border-top-left-radius: 0.25rem;
            border-top-right-radius: 0.25rem;
            padding-top: 0.5rem;
        }

        .c-num-plants-wrap {
            padding-left: 0.8rem;
            padding-right: 0.8rem;
            padding-bottom: 0.5rem;
            border-bottom-left-radius: 0.25rem;
        }

        .tray-format-column-first {
            margin-left: 0.8rem;
        }
    }


</style>


<style>
    .c-quentity-format-recommend .custom-control-input:checked ~ .custom-control-label::before {
        border-color: #048b84;
        background-color: #048b84;
    }

    .c-quentity-format-recommend .custom-control-label {
        line-height: 1.2;
    }
</style>
